import { DLButtonsChipsMenuItem } from "mlng";

export let globalMenuItems: DLButtonsChipsMenuItem[] = [
    { key: 'discover', value: "Discover", warningIcon: () => null },
    { key: 'explore', value: "Explore", warningIcon: () => null },
    /* { key: 'rankings', value: "Rankings", warningIcon: () => null },*/
    /*{  key: 'songoftheday', value: "Daily", warningIcon: () => null }*/
    { key: 'demos', value: "Demos", warningIcon: () => null },
    { key: 'milestones', value: "Milestones", warningIcon: () => null },
    /*{ key: 'timeline', value: "Roadmap", warningIcon: () => null }*/
    { key: 'about', value: "About", warningIcon: () => null },
    { key: 'system', value: "⚙️ My System", warningIcon: () => null },
];